"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.4934 2.7773 7.6602 2.5532-1.363 6.8153-2.7907-.4651v9.3196h-12v-9.3196l-2.7907.4651-1.363-6.8153 7.6337-2.5443C10.03 3.8024 10.6911 5 12.041 5c1.346 0 1.9449-1.208 2.4524-2.2228zm.9192 2.4146c-.8107 1.0511-2.0117 1.8082-3.3716 1.8082-1.3762 0-2.5949-.768-3.4352-1.8144l-4.4522 1.484.637 3.185 3.2093-.5349v9.6805h8V9.3198l3.2093.5349.637-3.185-4.4336-1.4778z"
  })];
};

exports.default = _default;